var map = {
	"./FERCAM_ICONE_DIVISIONALI_RGB-11.png": "f637",
	"./FERCAM_ICONE_DIVISIONALI_RGB-12.png": "c296",
	"./FERCAM_ICONE_DIVISIONALI_RGB-13.png": "7967",
	"./FERCAM_ICONE_DIVISIONALI_RGB-14.png": "b5a2",
	"./FERCAM_ICONE_DIVISIONALI_RGB-15.png": "3327",
	"./account_circle.png": "0c8d",
	"./back.png": "336c",
	"./check_Tavola.png": "05ab",
	"./communications.png": "24df",
	"./communications_email.png": "c825",
	"./communications_email_toread.png": "3d5a",
	"./comunicazioni_mobile.png": "ce94",
	"./comunicazioni_mobile_toread.png": "0100",
	"./comunicazioni_storico.png": "6c22",
	"./email.png": "9afb",
	"./en.png": "70ff",
	"./fercam_logo.png": "634b",
	"./info.png": "9417",
	"./info_red.png": "c060",
	"./it.png": "1dc1",
	"./logo.png": "cf05",
	"./logout.png": "bc8c",
	"./menu_close.png": "becc",
	"./menu_open.png": "2a11",
	"./mobile.png": "978f",
	"./news.png": "cd65",
	"./news_mobile.png": "364a",
	"./phone.png": "3547",
	"./quotations.png": "bf1c",
	"./quotazioni_mobile.png": "4e9a",
	"./support.png": "c042"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";